import React from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import _ from "lodash";
import * as actionCreators from "../../../store/analytics/chart-header/action-creators";
import styles from "./ChartHeader.css";
import { SELECT_EMPTY_VALUE, CHART_CTT, CHART_LAYERS } from "../../../services/managers/constants";
import { TOOLTIP_COMPARE_WITH, TOOLTIP_VIEW_CHART } from "../../../services/managers/string-literals";
import _Aux from "../../_Aux";
import ChartGranularity from "../ChartGranularity/ChartGranularity";
import ChartCostToTradeLotSizes from "../ChartCostToTradeLotSizes/ChartCostToTradeLotSizes";
import ChartDownload from "../ChartDownload/ChartDownload";
import chartMetaDataTransformer from "../../../services/transformers/chart-meta-data";

class ChartHeader extends React.Component {
  render() {
    // Show Lot Sizes for Cost To Trade chart
    let lotSizesDoc = null;
    if (this.props.whiteboard.selectedPrimaryChart === CHART_CTT || this.props.whiteboard.selectedComparisonChart === CHART_CTT) {
      lotSizesDoc = (
        <ChartCostToTradeLotSizes
          whiteboardIndex={this.props.whiteboardIndex}
          selectedCostToTradeLotSizes={this.props.whiteboard.selectedCostToTradeLotSizes}
          selectedPrimaryChart={this.props.whiteboard.selectedPrimaryChart}
          selectedComparisonChart={this.props.whiteboard.selectedComparisonChart}
        />
      );
    }

    // Layers selection
    let layerSelectorCheckboxesDoc = null;
    let layerSelectorDropdownDoc = null;

    let layerMappingObj = chartMetaDataTransformer.getApplicableChartLayers(
      this.props.whiteboard.selectedPrimaryChart,
      this.props.whiteboard.selectedPrimaryChartType,
      this.props.whiteboard.selectedComparisonChart,
      this.props.whiteboard.selectedComparisonChartType
    ).mapping;

    // Show checkboxes to show Layers selection, if any
    if (layerMappingObj && layerMappingObj.Checkboxes && layerMappingObj.Checkboxes.length) {
      layerSelectorCheckboxesDoc = layerMappingObj.Checkboxes.map((checkboxCode) => {
        let checkboxInfo = _.find(CHART_LAYERS, { Code: checkboxCode });
        return (
          <div key={this.props.whiteboardIndex + "_" + checkboxCode} className={styles["filter-control-wrap"]}>
            <label className={styles["label-inline"]} title={checkboxInfo.Tooltip}>
              <input
                type="checkbox"
                name={this.props.whiteboardIndex + "_" + checkboxCode}
                value={checkboxCode}
                checked={_.includes(this.props.whiteboard.selectedLayers, checkboxCode)}
                onChange={() => this.props.onSelectedChartLayerChange(this.props.whiteboardIndex, checkboxCode, "Checkbox")}
              />{" "}
              {checkboxInfo.Name}
            </label>
          </div>
        );
      });
    }

    // Disable Layer dropdown for overlay comparison
    let isLayerSelectorDropdownDisabled =
      this.props.whiteboard.selectedComparisonChart && this.props.whiteboard.selectedComparisonChart !== SELECT_EMPTY_VALUE
        ? { disabled: "disabled" }
        : {};

    // Show dropdown to show Layers selection, if any
    if (layerMappingObj && layerMappingObj.Dropdown && layerMappingObj.Dropdown.length) {
      let preselectedDropdownValue = null;
      layerSelectorDropdownDoc = layerMappingObj.Dropdown.map((dropdownCode) => {
        let dropdownInfo = _.find(CHART_LAYERS, { Code: dropdownCode });
        if (!preselectedDropdownValue) {
          preselectedDropdownValue = _.includes(this.props.whiteboard.selectedLayers, dropdownCode) ? dropdownCode : null;
        }
        return (
          <option key={dropdownInfo.Code} value={dropdownInfo.Code} title={dropdownInfo.Tooltip}>
            {dropdownInfo.Name}
          </option>
        );
      });
      layerSelectorDropdownDoc = (
        <div className={styles["filter-control-wrap"]}>
          <select
            value={preselectedDropdownValue}
            onChange={(event) =>
              this.props.onSelectedChartLayerChange(this.props.whiteboardIndex, event.target.value, "Dropdown", preselectedDropdownValue)
            }
            {...isLayerSelectorDropdownDisabled}>
            {layerSelectorDropdownDoc}
          </select>
        </div>
      );
    }

    // Overlay comparison is allowed for specific combinations only, otherwise disable it
    let isComparisonChartDropdownDisabled = this.props.whiteboard.comparisonCharts.length ? {} : { disabled: "disabled" };

    let granularityAndLayersDoc = null;
    if (this.props.whiteboard.chartDrawings.length) {
      granularityAndLayersDoc = (
        <div className={"grid " + styles["chart-drawings-granularity-container"]}>
          <div className={"grid__col-md-6 grid__col-sm-6 grid--align-center " + styles["grid-col-section-left"]}>
            {/* Granularity */}
            <div className={styles["filter-control-wrap"]}>
              <ChartGranularity
                whiteboardIndex={this.props.whiteboardIndex}
                granularities={this.props.whiteboard.granularities}
                selectedGranularity={this.props.whiteboard.selectedGranularity}
              />
            </div>
          </div>
          <div className={"grid__col-md-6 grid__col-sm-6 " + styles["grid-col-section-right"]}>
            {/* Layers */}
            {layerSelectorCheckboxesDoc}
            {layerSelectorDropdownDoc}
          </div>
        </div>
      );
    }

    return (
      <_Aux>
        <div className={styles["chart-header-component-container"]}>
          {/* FIRST ROW */}
          <div className={"grid " + styles["chart-drawings-filters-container"]}>
            <div className={"grid__col-md-10 grid__col-sm-10 grid--align-center " + styles["grid-col-section-left"]}>
              {/* Primary Charts */}
              <div className={styles["filter-control-wrap"]}>
                <label>Select Type of Analysis</label>
                <select
                  value={this.props.whiteboard.selectedPrimaryChart}
                  onChange={(event) => this.props.onSelectedPrimaryChartChange(this.props.whiteboardIndex, event.target.value)}>
                  {this.props.whiteboard.primaryCharts.map((chart) => (
                    <option key={chart.Code} value={chart.Code} title={chart.Tooltip}>
                      {chart.Name}
                    </option>
                  ))}
                </select>
              </div>
              {/* Lot Sizes */}
              {this.props.whiteboard.selectedPrimaryChart === CHART_CTT ? <div className={styles["lot-size-control-wrap"]}>{lotSizesDoc}</div> : null}
            </div>
            <div className={"grid__col-md-2 grid__col-sm-2 grid--align-center " + styles["grid-col-section-right"]}>
              {/* View */}
              <div className={styles["filter-control-wrap"]}>
                <button
                  id="viewChartButton"
                  className="btn pull-right"
                  onClick={() => this.props.onViewChartClick(this.props.whiteboardIndex)}
                  title={TOOLTIP_VIEW_CHART}>
                  View Chart
                </button>
              </div>
            </div>
          </div>

          {/* SECOND ROW */}
          <div className={"grid " + styles["chart-drawings-compare-container"]}>
            <div className={"grid__col-md-10 grid__col-sm-10 grid--align-center " + styles["grid-col-section-left"]}>
              {/* Comparison Charts */}
              <div className={styles["filter-control-wrap"]}>
                <label>Compare with</label>
                <select
                  value={this.props.whiteboard.selectedComparisonChart}
                  onChange={(event) => this.props.onSelectedComparisonChartChange(this.props.whiteboardIndex, event.target.value)}
                  {...isComparisonChartDropdownDisabled}
                  title={TOOLTIP_COMPARE_WITH}>
                  <option value={SELECT_EMPTY_VALUE}>Select</option>
                  {this.props.whiteboard.comparisonCharts.map((chart) => (
                    <option key={chart.Code} value={chart.Code} title={chart.Tooltip}>
                      {chart.Name}
                    </option>
                  ))}
                </select>
              </div>
              {/* Lot Sizes */}
              {this.props.whiteboard.selectedComparisonChart === CHART_CTT ? (
                <div className={styles["lot-size-control-wrap"]}>{lotSizesDoc}</div>
              ) : null}
            </div>
            <div className={"grid__col-md-2 grid__col-sm-2 " + styles["grid-col-section-right"]}>
              {/* Export */}
              <div className={styles["filter-control-wrap"]}>
                <ChartDownload
                  whiteboardIndex={this.props.whiteboardIndex}
                  isWhiteboardObsolete={this.props.whiteboard.isObsolete}
                  chartDrawingsLength={this.props.whiteboard.chartDrawings.length}
                />
              </div>
            </div>
          </div>
          {/* THIRD ROW */}
          {granularityAndLayersDoc}
        </div>
      </_Aux>
    );
  }
}

ChartHeader.propTypes = {
  whiteboardIndex: PropTypes.number.isRequired
};

const mapDispatchToProps = (dispatch) => ({
  onSelectedPrimaryChartChange: (whiteboardIndex, value) => dispatch(actionCreators.onSelectedPrimaryChartChange({ whiteboardIndex, value })),
  onSelectedComparisonChartChange: (whiteboardIndex, value) => dispatch(actionCreators.onSelectedComparisonChartChange({ whiteboardIndex, value })),
  onSelectedChartLayerChange: (whiteboardIndex, value, whichControl, oldValue) =>
    dispatch(actionCreators.onSelectedChartLayerChange({ whiteboardIndex, value, whichControl, oldValue })),
  onViewChartClick: (whiteboardIndex) => dispatch(actionCreators.onViewChartClick({ whiteboardIndex }))
});

export default connect(null, mapDispatchToProps)(ChartHeader);



// WEBPACK FOOTER //
// ./src/components/Analytics/ChartHeader/ChartHeader.js